import { render, staticRenderFns } from "./SpecimensPage.vue?vue&type=template&id=05999922&scoped=true"
import script from "./SpecimensPage.vue?vue&type=script&lang=js"
export * from "./SpecimensPage.vue?vue&type=script&lang=js"
import style0 from "./SpecimensPage.vue?vue&type=style&index=0&id=05999922&prod&lang=scss&scoped=true"
import style1 from "./SpecimensPage.vue?vue&type=style&index=1&id=05999922&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05999922",
  null
  
)

export default component.exports